import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'urba-top14';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('alumni', 'Alumni', uniform('alumni', '#FF0000', '#DDDDDD')),
  team('atletico-del-rosario', 'Atlético del Rosario', uniform('atletico-del-rosario', '#000000', '#DDDDDD')),
  team('belgrano-athletic', 'Belgrano Athletic', uniform('belgrano-athletic', '#6C3921', '#DDDDDD')),
  team('buenos-aires-crc', 'Buenos Aires', uniform('buenos-aires-crc', '#0E007F', '#DDDDDD')),
  team('casi', 'CASI', uniform('casi', '#00A6C7', '#DDDDDD')),
  team('champagnat', 'Champagnat', uniform('champagnat', '#023162', LIGHT)),
  team('cuba', 'CUBA', uniform('cuba', '#003B95', '#DDDDDD')),
  team('hindu', 'Hindú', uniform('hindu', '#002350', '#FFDA00')),
  team('la-plata-rc', 'La Plata RC', uniform('la-plata-rc', '#FFCC00', '#084081')),
  team('los-tilos', 'Los Tilos', uniform('los-tilos', '#FECC0D', LIGHT)),
  team('matreros', 'Matreros', uniform('matreros', '#DA251C', LIGHT)),
  team('newman', 'Newman', uniform('newman', '#9C2D3C', '#DDDDDD')),
  team('regatas-bella-vista', 'Regatas Bella Vista', uniform('regatas-bella-vista', '#FFD500', LIGHT)),
  team('sic', 'SIC', uniform('sic', '#00A7C9', '#000000'))
];

export const urbaTop14: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(27, 38, 391, 231) },
  teams
};
